export default __webpack_public_path__ + "static/media/servicetype_cnc.51f39db2.png";